// Environment configuration for API requests

// Base URL for API endpoints
export const BASE_URL = 'https://api.tgboty.top/tssxapi' // Development server URL

// API request timeout (in milliseconds)
export const TIMEOUT = 100000



// WEBPACK FOOTER //
// ./src/config/env.js